export const clubRoutes = {
	children: [{
		component: () => import(`@/view/club/ClubList.vue`),
		name: `ClubList`,
		path: ``
	}, {
		component: () => import(`@/view/club/Register.vue`),
		name: `RegisterClub`,
		path: `register`
	}, {
		children: [{
			component: () => import(`@/view/club/Competition.vue`),
			name: `ClubCompetition`,
			path: `competition`
		}, {
			component: () => import(`@/view/club/ClubMembership.vue`),
			name: `ClubMembership`,
			path: `membership`
		}, {
			component: () => import(`@/view/club/Subscription.vue`),
			meta: { hasRole: [ `club:owner` ] },
			name: `ClubSubscription`,
			path: `subscription`
		}, {
			component: () => import(`@/view/club/Team.vue`),
			meta: { hasRole: [ `club:admin`, `club:owner` ] },
			name: `ClubTeam`,
			path: `team`
		}, {
			component: () => import(`@/view/club/Home.vue`),
			name: `ClubHome`,
			path: ``
		}],
		component: () => import(`@/view/Blank.vue`),
		path: `:clubId`
	}],
	component: () => import(`@/view/OneSidebar.vue`),
	path: `/club`
};
